import { render, staticRenderFns } from "./EpgDisplay.vue?vue&type=template&id=341c8626&scoped=true"
import script from "./EpgDisplay.vue?vue&type=script&lang=js"
export * from "./EpgDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341c8626",
  null
  
)

export default component.exports